import { getCurrentUser } from "../../../utils/user";

interface PrivilegeCheckProps {
  user_functionalities: Array<string>;
  requiredDepartment?: string;
}

export const CanAccessFunctionality = ({
  user_functionalities,
  requiredDepartment,
}: PrivilegeCheckProps): boolean => {
  const user = getCurrentUser();

  const userRole = user?.role?.toUpperCase();
  const userDepartment = user?.department;
  const storedFunctionalities = getStoredFunctionalities();

  const isSuperAdmin = userRole === "SUPER ADMIN".toUpperCase();
  const hasFunctionality = user_functionalities.every((item) =>
    storedFunctionalities.includes(item)
  );
  const matchesDepartment =
    !requiredDepartment || requiredDepartment === userDepartment;

  const canAccess = isSuperAdmin || (hasFunctionality && matchesDepartment);

  return canAccess;
};

const getStoredFunctionalities = (): string[] => {
  try {
    const storedFunctionalities = localStorage.getItem("functionalities");
    if (!storedFunctionalities) {
      return [];
    }

    const parsedFunctionalities = JSON.parse(storedFunctionalities);
    return Array.isArray(parsedFunctionalities) ? parsedFunctionalities : [];
  } catch (error) {
    console.error("Failed to parse functionalities from localStorage:", error);
    return [];
  }
};

export const checkAccessFunctionality = (
  userFunctionalities: string[],
  requiredFunctionalities: string[],
  userRole?: string,
  userDepartment?: string,
  requiredDepartment?: string
): boolean => {
  const isSuperAdmin = userRole?.toUpperCase() === "SUPER ADMIN";
  const hasFunctionality = requiredFunctionalities.every((item) =>
    userFunctionalities.includes(item)
  );
  const matchesDepartment =
    !requiredDepartment || requiredDepartment === userDepartment;

  return isSuperAdmin || (hasFunctionality && matchesDepartment);
};
